import { useTranslation } from 'react-i18next';

export type TFunction = ReturnType<typeof useTranslation>['t'];

export default useTranslation;
